import { render, staticRenderFns } from "./Crear_Editar_Fichero.vue?vue&type=template&id=6039851a&scoped=true"
import script from "./Crear_Editar_Fichero.vue?vue&type=script&lang=js"
export * from "./Crear_Editar_Fichero.vue?vue&type=script&lang=js"
import style0 from "./Crear_Editar_Fichero.vue?vue&type=style&index=0&id=6039851a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6039851a",
  null
  
)

export default component.exports